export default __webpack_public_path__ + "e81c3d922db71cec0f8636d99ef47079.png";